import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {environment} from 'src/environments/environment';
import {Observable, Subject} from 'rxjs';
import {Router} from '@angular/router';
import {CustomerCareService} from '../../shared/customer-care.service';
import {SmagApiService} from '../../api/smag-api.service';
import {first} from 'rxjs/operators';
import * as moment from 'moment-timezone';
import {DEFAULT_TIMEZONE} from '../../i18n/i18n-defaults';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit, OnDestroy {

    private destroyed = new Subject<void>();

    @Input() withMenu: boolean;

    version: string;

    constructor(private readonly apiService: SmagApiService,
                private readonly customerCareService: CustomerCareService,
                private readonly router: Router) {
        this.version = null;
    }

    ngOnInit() {
        this.apiService.getVersions()
            .pipe(first())
            .subscribe(versions => this.version = versions.EMS);
    }

    ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
    }

    get copyright(): string {
        let tz: string;
        try {
            tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        } catch (e) {
            tz = DEFAULT_TIMEZONE;
        }
        return (environment.copyright as string).replace('$YEAR$', moment.tz(tz).year().toString());
    }

    get address(): string {
        return environment.address as string;
    }

    get customerCareEnabled(): Observable<boolean> {
        return this.customerCareService.customerCare;
    }

    onClickSupport() {
        const url = this.router.serializeUrl(this.router.createUrlTree(['/c', 'customer-care'], {
            queryParams: {},
            queryParamsHandling: 'merge'
        }));
        window.open(url, '_blank');
    }

    get isCustomerCareSelected(): boolean {
        const segments = this.router.parseUrl(this.router.url)
            .root.children.primary.segments
            .map(segment => segment.path);
        return segments[0] === 'c' && segments[1] === 'customer-care';
    }
}
